// dependencies
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage"

// contexts
import { useStorage } from "../../contexts/StorageContext"

// styles
import "./css/image-upload.css"


const ImageUpload = ({ folderName, onImagesUpload, isThumbnail = false }) => {
    const { storage } = useStorage()
    
    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files)
        const uploadedImages = []

        for (const file of files) {
            const storageRef = ref(storage, `/images/${folderName}/${isThumbnail ? 'thumbnail' : 'images'}/${file.name}`)
            const uploadTask = await uploadBytesResumable(storageRef, file)
            const url = await getDownloadURL(uploadTask.ref)
            uploadedImages.push(url) 
        }

        onImagesUpload(uploadedImages)  // pass urls to parent
    }

    return (
        <input
            className="imgae-upload-input"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            multiple={!isThumbnail}  // allow multiple files if it's not for thumbnail
        />
    )
}


export default ImageUpload
